import { Application } from "@hotwired/stimulus"
import SidebarController from "./sidebar_controller"
import FlashController from "./flash_controller"
import ModalFormController from "./modal_form_controller"
import SquadController from "./squad_controller"
import TomSelectController from "./tom_select_controller"
import MatchDaySheetController from "./match_day_sheet_controller"
import FixtureResultController from "./fixture_result_controller"
import FixtureEditController from "./fixture_edit_controller"
import MatchResultController from "./match_result_controller"
import FfaLookupController from "./ffa_lookup_controller"
import SignupFormController from "./signup_form_controller"
import TeamClaimController from "./team_claim_controller"
import TeamRegistrationController from "./team_registration_controller"
import UserRoleFieldsController from "./user_role_fields_controller"
import SwapTeamsController from "./swap_teams_controller"

const application = Application.start()

application.register("sidebar", SidebarController)
application.register("flash", FlashController)
application.register("modal-form", ModalFormController)
application.register("squad", SquadController)
application.register("tom-select", TomSelectController)
application.register("match-day-sheet", MatchDaySheetController)
application.register("fixture-result", FixtureResultController)
application.register("fixture-edit", FixtureEditController)
application.register("match-result", MatchResultController)
application.register("ffa-lookup", FfaLookupController)
application.register("signup-form", SignupFormController)
application.register("team-claim", TeamClaimController)
application.register("team-registration", TeamRegistrationController)
application.register("user-role-fields", UserRoleFieldsController)
application.register("swap-teams", SwapTeamsController)

export default application
